const CrossSell = ({ crossSell, loading = false }) => {
  const opportunities = Array.isArray(crossSell?.opportunities) ? crossSell.opportunities : [];
  const count = typeof crossSell?.count === "number" ? crossSell.count : opportunities.length;

  return (
    <div className="card cross-sell-card">
      <div className="card-header">
        <span className="card-header-icon">💡</span>
        <h3 className="card-header-title">Cross-Sell Opportunities</h3>
        <span className="badge badge--amber">{loading ? "Finding..." : `${count} found`}</span>
      </div>
      <div className="card-body">
        {loading ? (
          <p className="cross-sell-state">Analyzing the client&apos;s current Salesforce coverage for relevant opportunities...</p>
        ) : opportunities.length === 0 ? (
          <p className="cross-sell-state">No strong cross-sell opportunities identified from the client&apos;s current Salesforce policies.</p>
        ) : (
          opportunities.map((opp) => (
            <div key={opp.id} className="cross-sell-item">
              <div className="cross-sell-item-header">
                <span className="cross-sell-icon">{opp.icon}</span>
                <span className="cross-sell-type">{opp.type}</span>
              </div>
              <p className="cross-sell-description">{opp.description}</p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CrossSell;
